"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgClearFormat = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M4 17h8a1 1 0 010 2H4a1 1 0 010-2zm4.378-3.004C8.28 14.666 7.904 15 7.25 15c-.654 0-.945-.335-.872-1.004l1.626-10H5.707c-.51-.107-.743-.46-.702-1.056.04-.596.388-.91 1.042-.94h6.183c.544.063.8.393.766.99-.034.596-.36.932-.979 1.006h-2.013l-1.626 10zm6.596.61l2.168 2.169 2.168-2.168c.448-.464.904-.464 1.368 0 .463.463.463.919 0 1.367l-2.169 2.168 2.169 2.168c.455.456.455.912 0 1.368-.456.455-.912.455-1.368 0l-2.168-2.169-2.168 2.169c-.445.466-.901.466-1.367 0-.467-.467-.467-.922 0-1.368l2.168-2.168-2.168-2.168c-.457-.455-.457-.911 0-1.367.456-.457.912-.457 1.367 0v-.001z' }))); };
exports.default = SvgClearFormat;
//# sourceMappingURL=ClearFormat.js.map